// extracted by mini-css-extract-plugin
module.exports = {"welcomeBottom":"_62Hvvzb8","greetingContainer":"_1Q-MQCFc","mikeGreeting":"wRXTcTM1","mikeWelcome":"HgU6-BTP","mikeImage":"Ft6Kd0Qa","mikeEmail":"_1Yde54iK"};
    if(module.hot) {
      // 1754514928090
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  